module.exports = __webpack_public_path__ + "img/img1.d6fa7f56.png";